/* tecvan-product.js — shared interactive logic for tecvan product pages */
(function () {
  function init() {
    /* ── model viewer switcher (used by inline onclick="sw(...)") ── */
    window.sw = function (viewerId, btn, tabGroupId) {
      const v = document.getElementById(viewerId);
      if (v && btn.dataset && btn.dataset.src) v.setAttribute('src', btn.dataset.src);
      if (tabGroupId) {
        document.querySelectorAll('#' + tabGroupId + ' .vtab').forEach(b => b.classList.remove('active'));
        if (btn.classList) btn.classList.add('active');
      }
    };

    /* ── gallery carousel ───────────────────────────── */
    const galleries = {};
    function initGallery(key, mainId, stripId, counterId) {
      const mainEl    = document.getElementById(mainId);
      const stripEl   = document.getElementById(stripId);
      const counterEl = document.getElementById(counterId);
      if (!mainEl || !stripEl) return;
      const mains  = mainEl.querySelectorAll('img');
      const thumbs = stripEl.querySelectorAll('img');
      const state  = { mains, thumbs, counterEl, index: 0, total: mains.length };
      galleries[key] = state;
      thumbs.forEach((t, i) => t.addEventListener('click', () => galleryGoTo(key, i)));
      galleryGoTo(key, 0);
    }
    function galleryGoTo(key, i) {
      const s = galleries[key]; if (!s) return;
      const idx = (i + s.total) % s.total;
      s.mains.forEach(m => m.classList.remove('active'));
      s.thumbs.forEach(t => t.classList.remove('active'));
      if (s.mains[idx])  s.mains[idx].classList.add('active');
      if (s.thumbs[idx]) s.thumbs[idx].classList.add('active');
      if (s.counterEl) {
        const pad = n => String(n).padStart(2, '0');
        s.counterEl.textContent = pad(idx + 1) + ' / ' + pad(s.total);
      }
      s.index = idx;
    }
    function galleryStep(key, dir) {
      const s = galleries[key]; if (!s) return;
      galleryGoTo(key, s.index + dir);
    }
    /* expose so inline onclick="galleryStep('foo', -1)" still works */
    window.galleryStep = galleryStep;
    window.galleryGoTo = galleryGoTo;

    /* auto-discover galleries from data-gallery attributes on .motto-main */
    document.querySelectorAll('.motto-main[data-gallery]').forEach(el => {
      const key = el.dataset.gallery;
      if (!key) return;
      initGallery(key, el.id, key + 'Strip', key + 'Counter');
    });

    /* keyboard nav when gallery is in view */
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      const dir = e.key === 'ArrowLeft' ? -1 : 1;
      for (const key of Object.keys(galleries)) {
        const s = galleries[key];
        const mainEl = s.mains[0] && s.mains[0].parentElement;
        if (!mainEl) continue;
        const r = mainEl.getBoundingClientRect();
        const vh = window.innerHeight;
        if (r.top < vh * 0.75 && r.bottom > vh * 0.25) {
          galleryStep(key, dir);
          e.preventDefault();
          break;
        }
      }
    });

    /* ── fade hint on first 3D interaction ─────────── */
    document.querySelectorAll('.viewer-hint').forEach(hint => {
      let mv = hint.previousElementSibling;
      while (mv && mv.tagName && mv.tagName.toLowerCase() !== 'model-viewer') {
        mv = mv.previousElementSibling;
      }
      if (!mv) {
        const parent = hint.parentElement;
        if (parent) mv = parent.querySelector('model-viewer');
      }
      if (mv && mv.addEventListener) {
        mv.addEventListener('camera-change', () => { hint.style.opacity = '0'; }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
